import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modalConfirmEdit",
  tabindex: "-1",
  "aria-labelledby": "modalConfirmEdit",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title text-center fw-bold w-100" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "modal-body w-100 mx-2 text-break" }
const _hoisted_8 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4 border-bottom" }
const _hoisted_9 = { class: "w-max-content col-3 col-form-label" }
const _hoisted_10 = { class: "row mx-0 px-0 col-8 align-items-center ps-3" }
const _hoisted_11 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4 border-bottom" }
const _hoisted_12 = { class: "w-max-content col-3 col-form-label" }
const _hoisted_13 = { class: "row mx-0 px-0 col-8 align-items-center ps-3" }
const _hoisted_14 = { class: "pb-4 gx-3 mb-4 border-bottom d-flex align-items-center" }
const _hoisted_15 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_16 = { class: "px-3" }
const _hoisted_17 = { class: "pb-4 gx-3 mb-4 border-bottom d-flex align-items-center" }
const _hoisted_18 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_19 = { class: "px-3" }
const _hoisted_20 = { class: "pb-4 gx-3 mb-4 border-bottom d-flex align-items-center" }
const _hoisted_21 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_22 = { class: "px-3" }
const _hoisted_23 = { class: "pb-4 gx-3 mb-4 border-bottom d-flex align-items-baseline" }
const _hoisted_24 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_25 = { class: "px-3" }
const _hoisted_26 = { class: "mb-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = { class: "pb-4 gx-3 mb-4 border-bottom d-flex" }
const _hoisted_29 = { class: "w-max-content col-form-label col-lg-3" }
const _hoisted_30 = { class: "px-3 col-lg-8 py-2" }
const _hoisted_31 = { class: "text-center mb-4" }
const _hoisted_32 = { class: "row mx-0 px-0 d-flex justify-content-center flex-lg-row flex-column-reverse" }
const _hoisted_33 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_34 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4" }

import { computed, onMounted, PropType, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import communityManagerServices from '@/services/community-managers.services'
import { USER_MANAGEMENT_STORE } from '@/store/constants'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: {
    type: Object,
    default: () => ({
      available: false,
      is_contact_admin: '',
    }),
  },

  messageModalCompleted: {
    type: Function as PropType<() => void | undefined>,
  },
},
  emits: ['isContactAdmin'],
  setup(__props, { emit }) {

const props = __props

const router = useRouter()
const store = useStore()

const dataInfor = computed(() => store.getters[USER_MANAGEMENT_STORE.GETTERS.ADMINNISTRATOR_INFOR]?.administratorInfor)





// 2022/09/15 TienNV Fix double click button confirm edit
const modalConfirm = ref()
const modalSuccess = ref()

onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('modalConfirmEdit'))
  modalSuccess.value = new Modal(document.getElementById('modalEditUserAdmin'))
})
const loading = ref(false)
const onSubmit = async (): Promise<void> => {
  loading.value = true
  try {
    const response = await communityManagerServices.updateAdministratorApi({
      id: router.currentRoute.value.params?.id,
      management_no: router.currentRoute.value.params?.management_no,
      data: props.data,
    })

    if (response.status === 200) {
      props.messageModalCompleted(false)
      emit('isContactAdmin', props.data.is_contact_admin)
      //2022/09/15 TienNV Fix double click button confirm edit
      modalConfirm.value.hide()
      modalSuccess.value.show()
      setTimeout(() => {
        loading.value = false
      }, 2000)
      return
    }
    props.messageModalCompleted(true)
    modalConfirm.value.hide()
    modalSuccess.value.show()
    loading.value = false
  } catch (error) {
    props.messageModalCompleted(true)
    modalConfirm.value.hide()
    modalSuccess.value.show()
    loading.value = false
    console.log(error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('CC40title')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(translate)('nameKanji')), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(dataInfor)?.family_name + ' ' + _unref(dataInfor)?.given_name), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(translate)('nameKatakana')), 1),
            _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(dataInfor)?.family_name_kana + ' ' + _unref(dataInfor)?.given_name_kana), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(translate)('SB20belong')), 1),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(dataInfor)?.department_name), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)('email')), 1),
            _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(dataInfor)?.email), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(translate)('dateOfBirth')), 1),
            _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(dataInfor)?.birthday), 1)
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(translate)('CC10contractor')), 1),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, _toDisplayString(__props.data.is_contact_admin ? '契約担当者にする' : '契約担当者にしない'), 1),
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_unref(translate)('CC40careful')) + " ", 1),
                  _hoisted_27,
                  _createTextVNode(" " + _toDisplayString(_unref(translate)('CC40carefulContractor')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(translate)('OE30usageSettings')), 1),
              _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(translate)(__props.data.available ? 'OE30available' : 'OE10pause')), 1)
            ]),
            _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(translate)('CD40textConfirm')), 1),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createVNode(Button, {
                  title: _unref(translate)('titleButtonEdit'),
                  type: 'secondary',
                  "data-bs-dismiss": "modal"
                }, null, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(Button, {
                  title: _unref(translate)('update'),
                  type: 'secondary',
                  onClick: onSubmit,
                  loading: loading.value,
                  disabled: loading.value
                }, null, 8, ["title", "loading", "disabled"])
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})